// extracted by mini-css-extract-plugin
export var button = "_f5-4";
export var hasDarkBackground = "_f5-7";
export var hasLightBackground = "_f5-6";
export var iconWrapper = "_f5-0";
export var large = "_f5-2";
export var medium = "_f5-1";
export var small = "_f5-5";
export var xsmall = "_f5-3";